export default "__VITE_ASSET__D9MVIv0u__"